import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

/**
 * React Query hook for fetching story thumbnails with automatic caching and deduplication
 */
export function useStoryThumbnail(storyId: string) {
    return useQuery({
        queryKey: ["story-thumbnail", storyId],
        queryFn: () => apiClient.fetchStoryThumbnail(storyId),
        staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
        gcTime: 10 * 60 * 1000, // Keep in memory for 10 minutes
        retry: 2, // Retry failed requests twice
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    });
}
